import { type FunctionalComponent, h } from '@stencil/core';
import type { IDashboardTabCarouselItem } from '../../../../types/subcomponents-types.type';
import { SearchResultTag } from '../../../../search-result-tag/search-result-tag';
import type { SearchProduct } from '../../../../../../../../api/SearchApi';

export const DashboardCarouselItem: FunctionalComponent<
    IDashboardTabCarouselItem
> = ({ ...props }) => {
    return props.products.map((doc, index) => {
        return (
          <SearchResultTag
            doc={doc as unknown as SearchProduct}
            index={index + props.resultIndexOffset}
            resultRenderer={props.resultRenderer}
            labelProvider={(e, f) => props.labelProvider(e, f)}
            country={props.country}
            language={props.language}
            gridView={true}
            isEcommerceMode={props.isEcommerceMode}
            eShop={props.eShop}
            rtl={props.rtl}
            strategies={props.strategies}
            resultClickAnalytics={props.resultClickAnalytics}
            isDashboardView={true}
            isDashboardListVariant={false}
            lazyLoadImages={props.lazyLoadImages}
            isSubstitutionTool={props.isSubstitutionTool}
            eolProductsNumber={props.resultIndexOffset}
            wcEventData={props.wcEventData}
            isUnifiedCheckout={props.isUnifiedCheckout}
          />
        );
    });
};
